import React, {FunctionComponent} from "react";
import {useStorageTranslateContext} from "../../../contexts/storage";
import {useModelContext} from "@app/contexts/model";
import {observer} from "mobx-react";
import {Typography} from "@mui/material";
import {useStorageConfirmTranslateContext} from "@app/modules/ConfirmTranslate/contexts/storage";


export const SelectedTranslation: FunctionComponent = observer(() => {

    const {translateStore} = useStorageTranslateContext();
    const {languageModel} = useModelContext();
    const {confirmTranslateStore} = useStorageConfirmTranslateContext()

    const mainID = translateStore.mainLanguageId;
    const targetID = translateStore.targetLanguageId;

    const acceptedTargetID = confirmTranslateStore.languageToAccept


    let b = mainID !== '' && (targetID !== '' || acceptedTargetID !== "");


    const categoryLangResponse = languageModel.dataCategory.get()

    let mainDescription = ''
    let  targetDescription = ''
    let targetDescriptionAccepted = ''

        categoryLangResponse && categoryLangResponse.main.map(value => {
            if (value.key === mainID) {
                mainDescription = value.name
              }
            })

        categoryLangResponse && categoryLangResponse.target.map(value => {
            if (value.key === targetID) {
                targetDescription = value.name
        }  else if (value.key === acceptedTargetID) {
                targetDescriptionAccepted = value.name
            }
    })


    return <div>
        {b ? <Typography variant={'h5'}>Translation from {mainDescription} into {targetDescription || targetDescriptionAccepted}</Typography> : 'Languages not selected'}
    </div>
})




